function mQueryDomNodes(selectors, context) {
  selectors = selectors || {};
  context = context || document;
  return Object.entries(selectors).reduce(function (acc, entry) {
    var name = entry[0];
    var selector = entry[1];
    var findOne = typeof selector === "string";
    var sl = findOne ? selector : selector[0];
    if (context) acc[name] = context[findOne ? "querySelector" : "querySelectorAll"](sl);
    if (!findOne && acc[name]) acc[name] = Array.prototype.slice.call(acc[name]);
    return acc;
  }, {});
}

if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };
      this.classes = {
        grid: 'm:grid',
        hidden: 'm:hidden',
        swiper: 'swiper-container',
        swiperWrapper: 'swiper-wrapper'
      };
      this.domNodes = mQueryDomNodes(this.selectors, this);

      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      const boot = () => this.init();
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
      } else {
        boot();
      }
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      if (!this.enableSlider) return;
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        setTimeout(() => this.initSlider(), 50);
        return;
      }
      const { slideContainer, slideControls, slideInner } = mQueryDomNodes(this.selectors, this);

      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      const itemCount = parseInt(this.items);
      const totalCount = parseInt(this.total);
      const isNotesRow = this.closest(".s_explore_favourite");

      this.options = {
        slidesPerView: this.expanded && totalCount > itemCount ? itemCount - 1 : itemCount - 4,
        loop: totalCount > itemCount,
        slidesPerGroup: 1,
        showNavigation: true,
        showPagination: true,
        parallax: !isNotesRow,
        autoplay: this.autoplay
          ? {
            delay: parseInt(this.autoplaySpeed) * 1000,
          }
          : false,
        pagination:
          this.paginationType == "fraction"
            ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              type: "fraction",
            }
            : {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + paginationIcon + "</span>";
              },
            },
        navigation: nextButton || prevButton ? {
          nextEl: nextButton && nextButton,
          prevEl: prevButton && prevButton
        } : false,
        autoHeight: true,
        breakpoints: isNotesRow
          ? {
            390: { slidesPerView: 4 },
            768: { slidesPerView: 6 },
            1024: { slidesPerView: itemCount },
            1280: { slidesPerView: itemCount },
          }
          : {
            390: {
              slidesPerView: this.expanded && totalCount > itemCount ? itemCount - 1 : itemCount - 2.7,
            },
            480: {
              slidesPerView: this.expanded && totalCount > itemCount ? itemCount - 1 : itemCount - 2.7,
            },
            768: {
              slidesPerView: this.expanded && totalCount > itemCount ? itemCount - 1 : itemCount - 1.5,
            },
            1024: {
              slidesPerView: this.expanded && totalCount > itemCount ? itemCount : itemCount - 1,
            },
            1280: {
              slidesPerView: this.expanded && totalCount > itemCount ? itemCount + 1 : itemCount,
            },
          }
      };

      if (typeof this.slider !== 'object') {
        slideContainer.classList.add(this.classes.swiper);
        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);
        slideControls && slideControls.classList.remove(this.classes.hidden);
        this.slider = new MinimogLibs.Swiper(slideContainer, this.options);
      }
    }

    destroySlider() {
      const { slideContainer, slideControls, slideInner } = mQueryDomNodes(this.selectors, this);

      slideContainer.classList.remove(this.classes.swiper);
      slideInner.classList.remove(this.classes.swiperWrapper);
      slideInner.classList.add(this.classes.grid);
      slideControls && slideControls.classList.add(this.classes.hidden);

      if (typeof this.slider === 'object') {
        this.slider.destroy();
        this.slider = false;
      }
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}
